module.exports = __webpack_public_path__ + "img/3.4b60420c.jpg";